<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_lawyer"
        title="Rechtliche Informationen"
        @save="saveFirmAccounting">
        <h2>Impressumsangaben</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Umsatzsteueridentifikationsnummer"
                property="taxIdentificationNumber"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Steuernummer"
                property="taxNumber"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Versicherungsnummer"
                property="insuranceNumber"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Händlernummer"
                property="dealerNumber"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Handelsregisternummer"
                property="tradeRegisterNumber"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Handelsregistersitz"
                property="tradeRegisterPlace"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Firmensitz"
                property="firmPlace"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Rechtsdienstleistungsregister"
                property="legalServiceRegister"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Vertretungsberechtigte"
                property="legalRepresentatives"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Gesellschafter"
                property="shareholder"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Vorstand"
                property="executive"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Vorstandsvorsitzender"
                property="chairmanExecutive"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Aufsichtsratsvorsitzender"
                property="chairmanSupervisory"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Individuelles Firmendetail (Signatur)"
                property="individualDetail"
                type="autogrowtextarea"/>
        </b-row>
        <div v-if="formContext.permissions.canEditBilling">
            <hr>
            <h2>Abrechnung</h2>
            <b-row>
                <csp-desktop-info-card-element
                    class="col-3"
                    :form-context="formContext"
                    label="Firmennummer"
                    property="firmNumber"
                    type="text"/>
                <csp-desktop-info-card-element
                    class="col-3"
                    :form-context="formContext"
                    label="Adressnummer"
                    property="addressNumber"
                    type="text"/>
                <csp-desktop-info-card-element
                    class="col-3"
                    :form-context="formContext"
                    label="Personenkonto"
                    property="personalAccount"
                    type="text"/>
                <csp-desktop-info-card-element
                    class="col-3"
                    :form-context="formContext"
                    label="Rechnungsempfänger E-Mail"
                    property="accountingEmail"
                    type="text"/>
                <csp-desktop-info-card-element
                    class="col-3"
                    :form-context="formContext"
                    label="Kostenstelle"
                    property="costCentre"
                    type="text"/>
                <csp-desktop-info-card-element
                    class="col-3"
                    :form-context="formContext"
                    label="Fußtext"
                    property="footerText"
                    type="textarea"/>
                <csp-desktop-info-card-element
                    class="col-3"
                    :form-context="formContext"
                    :hide-label="true"
                    label="Manuelle Nachbearbeitung Rechnung"
                    property="invoiceNeedsManualAdjustment"
                    type="checkbox"/>
                <csp-desktop-info-card-element
                    class="col-3"
                    :form-context="formContext"
                    label="Deckelung AH Haftpflichtgebühr / Monat"
                    property="monthlyFeeCap"
                    type="number"/>
                <csp-desktop-info-card-element
                    class="col-12"
                    :form-context="formContext"
                    label="Besonderheiten Abrechnung"
                    property="billingModalityRemarks"
                    type="autogrowtextarea"/>
            </b-row>
        </div>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();

    export default {
        name: 'FirmAccounting',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        computed: {
            firmId() {
                return this.$route.params.firmId;
            },
        },
        methods: {
            saveFirmAccounting(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmRepository.saveFirmAccounting(this.firmId, postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
        },
    }
</script>
